module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_1_EE-5666d3153d6e276989e9f70bbba3345b.svg";